export default function ProcessGuide() {
  const steps = [
    {
      number: '01',
      title: '사전 분석 및 가능성 진단',
      subtitle: '무료 상담',
      description: '건축물대장, 항공사진 분석을 통해 2024년 말 이전 완공 여부 및 면적 기준 충족 여부 확인',
      duration: '1-2일',
    },
    {
      number: '02',
      title: '현장 조사 및 설계 도서 작성',
      subtitle: '건축사 업무',
      description: '건축사가 직접 방문하여 현황 측량, 위반 부분에 대한 정밀 도면 작성 및 현장 조사서 작성',
      duration: '5-7일',
    },
    {
      number: '03',
      title: '양성화 신청 및 심의 접수',
      subtitle: '행정 대행',
      description: '지자체에 특정건축물 신고서 접수, 건축위원회 심의 대응 (구조 안전, 소방, 피난 기준 소명)',
      duration: '10-15일',
    },
    {
      number: '04',
      title: '이행강제금 납부',
      subtitle: '과태료 해결',
      description: '이행강제금 5회분 납부 완료 시 합법화 승인. 체납된 금액이 있다면 납부 필요',
      duration: '즉시',
    },
    {
      number: '05',
      title: '건축물대장 등재 및 등기',
      subtitle: '합법화 완료',
      description: '위반건축물 딱지(노란색) 삭제 → 합법적 건축물 등재 → 재산권 행사 가능',
      duration: '3-5일',
    },
  ];

  return (
    <section className="py-20 bg-[#F5F3EF]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Text Area */}
          <div>
            <div className="inline-block border border-gray-400 px-4 py-1 rounded-full mb-6">
              <span className="text-sm text-gray-600 font-light">STEP BY STEP</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-gray-900">복잡한 행정 절차,</span>
              <br />
              <span className="text-gray-600">전문가가 대신합니다</span>
              <span className="ml-2">🤝</span>
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed mt-8 mb-8">
              건축사 현장 조사부터 건축위원회 심의 대응, 이행강제금 납부, 건축물대장 등재까지 원스톱 대행 서비스를 제공합니다
            </p>

            {/* Stats */}
            <div className="flex gap-12 mb-8">
              <div>
                <div className="text-5xl font-bold text-[#2C4A3E] mb-2">5단계</div>
                <div className="text-sm text-gray-600">완료 프로세스</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-[#2C4A3E] mb-2">30일</div>
                <div className="text-sm text-gray-600">평균 처리 기간</div>
              </div>
            </div>

            <a href="#" className="text-[#2C4A3E] font-semibold underline hover:text-[#1f3329] transition-colors">
              상세 절차 보기 →
            </a>
          </div>

          {/* Right Steps Area */}
          <div className="space-y-6">
            {steps.map((step, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 bg-[#2C4A3E] rounded-full flex items-center justify-center">
                      <span className="text-white font-bold text-lg">{step.number}</span>
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                      <span className="text-sm text-[#D97642] font-semibold bg-[#FFF4E6] px-3 py-1 rounded-full whitespace-nowrap">
                        {step.duration}
                      </span>
                    </div>
                    <p className="text-sm text-[#5C4033] font-medium mb-2">{step.subtitle}</p>
                    <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
